export default __webpack_public_path__ + "static/media/options.cce41a4d.svg";